import React, { Component } from 'react';
import logo from './simpsons_mob.gif';
import './App.css';
import Button from '@material-ui/core/Button';
import NewIdeaForm from './NewIdeaForm';
import Idea from './Idea';
import Typography from '@material-ui/core/Typography';

import NewIdea from './NewIdea';
import Divider from '@material-ui/core/Divider';
import fire from './fire';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from "@material-ui/core/TextField/TextField";
import PositionedSnackbar from "./Snackbar";
import firebase from 'firebase';



const post = {
  title: "build a beer bot",
  description : "lets build a beer bot",
  upvotes: 20,
  downvotes: 10
}





class App extends Component {

  state = {
    posts: {}
  }

  bindPosts = (snapshot) => {
    this.setState({posts: snapshot.val()})

  }
  componentDidMount(){
    var postsRef = fire.database().ref('posts/')

    postsRef.on('value', this.bindPosts);

    firebase.auth().onAuthStateChanged((user) => {
      this.setState(this.state);
      console.log("fired")
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });

  };


  handleSignupButtonClick = () => {
    let provider = new firebase.auth.GoogleAuthProvider()


    firebase.auth().signInWithPopup(provider).then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // setter


      // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });
  }

  handleLogoutButtonClick = () => {

    firebase.auth().signOut().then(function() {
      console.log('Signed Out');
    }, function(error) {
      console.error('Sign Out Error', error);
    });
  }

  render() {

    var user = firebase.auth().currentUser;

    return (
      <div className="App">
        <header className="App-header">
          {/*<img src={logo} style={{width:'250px'}}alt="logo" />*/}
          <h1 className="App-title">1001 Problems</h1>
          <h2 >Find great problems to solve.</h2>

        </header>




        <NewIdeaForm/>

        {
          (user != null) ?  <Button  variant="contained" color="secondary" onClick={()=> this.handleLogoutButtonClick()}>
              Logout
            </Button>:
            <Button  variant="contained" color="primary" onClick={()=> this.handleSignupButtonClick()}>
              Sign in with Google
            </Button>

        }

        {/*<PositionedSnackbar/>*/}
        <Grid container spacing={24} direction="row"
              style={{padding: "1rem"}} >

          { this.state.posts ?
            Object.keys(this.state.posts).map(key => {
              return <Grid key={key}  item xs={12} sm={6} md={3}>
                <NewIdea  ref_id={key} post={this.state.posts[key]} />
              </Grid>
            }) : null
          }


        </Grid>



 
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js